export enum BankaHesabiTipi {
    iban="iban",
    hesap_numarasi="hesap_no"
}